import { useContainer } from "unstated-next";

import Loadable from "../../../components/common/loadable";
import AdminIntegrationsContainer, { IntegrationsView } from "../AdminIntegrationsContainer";
import IntegrationCreate from "../components/AdminIntegrations/IntegrationCreate";
import IntegrationEdit from "../components/AdminIntegrations/IntegrationEdit";
import IntegrationList from "../components/AdminIntegrations/IntegrationList";

const IntegrationSettings = () => {
    const { view, isLoading } = useContainer(AdminIntegrationsContainer);
    const renderView = () => {

        switch (view) {
            case IntegrationsView.List:
                return <IntegrationList />;
            case IntegrationsView.Edit:
                return <IntegrationEdit />;
            case IntegrationsView.Create:
                return <IntegrationCreate />;
            default:
                return null;
        }
    };

    return (
        <Loadable isLoading={isLoading} fullScreen={false}>
            {renderView()}
        </Loadable>
    );
}

export default IntegrationSettings;